import {
  Box,
  Button,
  Card,
  createStyles,
  Stack,
  Title,
  Text
} from '@mantine/core';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { FiCheck } from 'react-icons/fi';

import ChecklistComponent from '@unserkunde/enscompare-components/src/components/feedback/Checklist';
import Price from '@unserkunde/enscompare-components/src/components/feedback/Price';

import Eyebrow from '../feedback/Eyebrow';

export const useStyles = createStyles((theme) => {
  return {
    container: {
      overflow: 'visible',
    },
  };
});

const PremiumServiceCard = ({
  title = null,
  value = null,
  eyebrow = null,
  price = null,
  btnLabel = null,
  btnLabelDone = null,
  btnCallback = null,
  checklist = null,
  agbText = null,
  disableUncheck = null,
  agbAboveButton = null,
  fullHeight = null,
  buttonProps = null as null | Partial<React.ComponentProps<typeof Button>>,
  ...rest
}) => {
  const { classes } = useStyles();

  const [isAdded, setAdded] = useState(false);

  useEffect(() => {
    if (value === null || value === undefined) return;
    setAdded(value);
  }, [value]);

  const handleBtnClick = useCallback(
    (event) => {
      const newValue = !isAdded;
      if (newValue === false && disableUncheck) return;
      setAdded(newValue);
      btnCallback(event, newValue);
    },
    [btnCallback, setAdded, isAdded, disableUncheck],
  );

  return (
    <Card
      h={fullHeight ? '100%' : undefined}
      {...rest}
      className={classes.container}
    >
      {!eyebrow ? null : <Eyebrow text={eyebrow} />}

      <Box px={0} h={fullHeight ? '100%' : undefined}>
        <Stack h={fullHeight ? '100%' : undefined}>
          <Title order={3} my="md">
            {title}
          </Title>
          <ChecklistComponent {...checklist} />

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Price {...price} size="md" />
          </Box>
          {fullHeight && <Box style={{ flexGrow: 1 }} />}
          {!agbText || !agbAboveButton ? null : <Text>{agbText}</Text>}

          <Button
            fullWidth
            compact
            variant={isAdded ? 'filled' : 'outline'}
            color={'primary'}
            leftIcon={isAdded ? <FiCheck color="white" /> : null}
            onClick={handleBtnClick}
            {...buttonProps}
          >
            {isAdded ? btnLabelDone : btnLabel}
          </Button>
          {!agbText || agbAboveButton ? null : <Text>{agbText}</Text>}
        </Stack>
      </Box>
    </Card>
  );
};

PremiumServiceCard.defaultProps = {
  title: null,
  eyebrow: null,
  price: null,
  btnLabel: null,
  btnLabelDone: null,
  agbText: null,
  btnCallback: () => {},
  checklist: null,
  disableUncheck: false,
  value: null,
  agbAboveButton: false,
  fullHeight: false,
};

export default PremiumServiceCard;
